import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Print from 'vue-print-nb'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/router/permission'
import '@/assets/iconfont/iconfont.css'
import '@/assets/font/font.css'
import echarts from 'echarts';
Vue.prototype.$echarts=echarts;
Vue.filter('dateFormat',function(originVal){
   
  const dt = new Date(originVal)
  const y = dt.getFullYear()
  const m = (dt.getMonth()+ 1 + '').padStart(2,'0')
  const d =(dt.getDate() + '').padStart(2,'0')
  const hh =(dt.getHours() + '').padStart(2,'0')
  const mm =(dt.getMinutes() + '').padStart(2,'0')
  const ss =(dt.getSeconds() + '').padStart(2,'0')
  return `${y}-${m}-${d}-${hh}:${mm}:${ss}`
})
 

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Print);

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
